import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '../../../infrastructure/config';
import { RequestHelper } from '../../../infrastructure/core/requestHelper';
import { Category } from '../../../models/DTO/categeroies/category';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {

  private getRootCategoryURL : string = Config.api + "category/?perPage=130";
  private getSubCategoryURL : string = Config.api + "category/"


  constructor(private httpClient: HttpClient) {
  }

  getAllRootCategories() {
    return this.httpClient.get<Category>(this.getRootCategoryURL);
  }

  getParentCategory(childCategoryUUID: string) {
    const params = childCategoryUUID + '?perPage=130&depth=1&reverse=1';
    return this.httpClient.get<Category>(this.getSubCategoryURL + params);
  }

  getSubcategories(rootCategory: string, depth: number = 1) {
    const urlQuery = rootCategory + "?perPage=130&depth=" + depth;
    return this.httpClient.get<Category>(this.getSubCategoryURL + urlQuery);
  }

  getCategoryInfo(categoryUUID: string) {
    return this.httpClient.get(this.getSubCategoryURL + categoryUUID);
  }
}
